import { render, staticRenderFns } from "./MyPerPageComponent.vue?vue&type=template&id=d871a9ae&"
import script from "./MyPerPageComponent.vue?vue&type=script&lang=js&"
export * from "./MyPerPageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d871a9ae')) {
      api.createRecord('d871a9ae', component.options)
    } else {
      api.reload('d871a9ae', component.options)
    }
    module.hot.accept("./MyPerPageComponent.vue?vue&type=template&id=d871a9ae&", function () {
      api.rerender('d871a9ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/table/MyPerPageComponent.vue"
export default component.exports